import { Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import Register from '../pages/Register';
import Product from '../pages/Product';
import Products from '../pages/Products';
import NotFound from '../pages/404';
import SignIn from '../pages/SignIn';
import { PayContextProvider } from '../context/PayContext';
import { LocationContextProvider } from '../context/LocationContext';
import ProtectedRoutes from './ProtectedRoutes';
import Panel from '../pages/user/Panel';
import ShopingCart from '../pages/user/ShopingCart';
import Payment from '../pages/user/Payment';
import PaymentFinal from '../pages/user/PaymentFinal';
import Success from '../pages/Success';

const index = () => {
  return (
      <PayContextProvider>
        <LocationContextProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/products/:id" element={<Products />} />
            <Route path="/products/cat/:id" element={<Products />} />
            <Route path="/search/:name" element={<Products search={true} />} />
            <Route path="/success" element={<Success />} />
            <Route path="*" element={<NotFound />} />
            <Route element={<ProtectedRoutes />}>
              <Route path="/panel" element={<Panel />} />
              <Route path="/cart" element={<ShopingCart />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/step3" element={<PaymentFinal />} />
            </Route>
          </Routes>
        </LocationContextProvider>
      </PayContextProvider>
  );
};

export default index;
